import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=06bdae43&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdae43",
  null
  
)

export default component.exports